import { useBalance } from "wagmi";
import { contractAddresses } from "../../../../meta";
import { Card, Typography, FlexCol, Divider } from "../../../../shared";
import { displayTokens } from "../../../../utils";
import { useGetContractBalanceByToken } from "../../../state/erc20/useGetContractBalanceByToken";
import { HorizontalRow } from "../components/HorizontalRow/HorizontalRow";

export const ReserveHolderBalances = () => {
  const ethData = useBalance({ address: contractAddresses.ReserveHolder });

  const { displayData: rwDisplayValueCHI } = useGetContractBalanceByToken(
    "CHI",
    contractAddresses.ReserveHolder
  );
  const { displayData: rwDisplayValueStETH } = useGetContractBalanceByToken(
    "stETH",
    contractAddresses.ReserveHolder
  );
  const { displayData: rwDisplayValueUSC } = useGetContractBalanceByToken(
    "USC",
    contractAddresses.ReserveHolder
  );
  const { displayData: rwDisplayValueWETH } = useGetContractBalanceByToken(
    "WETH",
    contractAddresses.ReserveHolder
  );

  return (
    <Card hasBorder className="p-4">
      <Typography>Reserve Holder/</Typography>
      <br />
      <FlexCol className="gap-2">
        <HorizontalRow
          name="ETH balance"
          value={displayTokens(ethData?.data?.value, {})}
          isFetched={ethData.isFetched}
        />
        <Divider />
        <HorizontalRow name="CHI balance" {...rwDisplayValueCHI} />
        <Divider />
        <HorizontalRow name="stETH balance" {...rwDisplayValueStETH} />
        <Divider />
        <HorizontalRow name="USC balance" {...rwDisplayValueUSC} />
        <Divider />
        <HorizontalRow name="WETH balance" {...rwDisplayValueWETH} />
      </FlexCol>
    </Card>
  );
};
